import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const JsonIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 256 256"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g id="SVGRepo_iconCarrier">
      <defs>
        <linearGradient
          x1="15.7913036%"
          y1="14.7370493%"
          x2="91.0087401%"
          y2="85.2281246%"
          id="linearGradient-1"
        >
          <stop stopColor="currentColor" offset="0%" />
          <stop stopColor="currentColor" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="82.1356665%"
          y1="85.2373953%"
          x2="-3.11315442%"
          y2="14.7900497%"
          id="linearGradient-2"
        >
          <stop stopColor="currentColor" offset="0%" />
          <stop stopColor="currentColor" offset="100%" />
        </linearGradient>
      </defs>
      <g>
        <path
          d="M127.78336,190.559312 C184.419648,267.767856 239.846672,169.00968 239.765248,109.620512 C239.668928,39.402832 168.499792,0.158608 127.73696,0.158608 C62.309088,0.158608 0,54.232336 0,128.216032 C0,210.449632 71.424608,255.999984 127.73696,255.999984 C114.993808,254.165184 72.52704,245.065664 71.956288,147.253152 C71.572496,81.098592 93.5364,54.668336 127.64472,66.294672 C128.408608,66.577984 165.266992,81.117888 165.266992,128.61552 C165.266992,175.911392 127.78336,190.559312 127.78336,190.559312 L127.78336,190.559312 Z"
          fill="url(#linearGradient-1)"
        />
        <path
          d="M127.717232,66.241296 C90.293152,53.342288 44.4484,84.186592 44.4484,145.967392 C44.4484,246.84416 119.20128,255.999984 128.263056,255.999984 C193.690928,255.999984 256,201.926256 256,127.94256 C256,45.70896 184.575392,0.158608 128.263056,0.158608 C143.860032,-2.001392 212.328448,17.038464 212.328448,110.617488 C212.328448,171.64336 161.203872,204.865424 127.951696,190.670992 C127.187808,190.38768 90.329424,175.847776 90.329424,128.350144 C90.329424,81.054272 127.717232,66.241296 127.717232,66.241296 L127.717232,66.241296 Z"
          fill="url(#linearGradient-2)"
        />
      </g>
    </g>
  </svg>
)
const ForwardRef = forwardRef(JsonIcon)
export { ForwardRef as ReactComponent }
